//POLLS ACTION 
export const ADD_QUESTION_FOR_POLL = "ADD_QUESTION_FOR_POLL"
export const ADD_DESCRIPTION_FOR_POLL = "ADD_DESCRIPTION_FOR_POLL"
export const ADD_DATE_FOR_POLL = "ADD_DATE_FOR_POLL"
export const ADD_TAGS_FOR_POLL = "ADD_TAGS_FOR_POLL"
export const TOGGLE_IS_ANSWER_FOR_POLL = "TOGGLE_IS_ANSWER_FOR_POLL"
export const ADD_CATEGORY = "ADD_CATEGORY"
// POLLS ACTION ENDS

// QUESTION ACTION
export const ADD_OPTIONS_FOR_POLL = "ADD_OPTIONS_FOR_POLL"
export const ADD_QUESTION = "ADD_QUESTION"
export const ADD_DESCRIPTION = "ADD_DESCRIPTION"
export const ADD_DATE = "ADD_DATE"
export const ADD_TAGS = "ADD_TAGS"
export const ADD_CATEGORY_QUESTION = "ADD_CATEGORY_QUESTION"
export const IS_ANSWER = "IS_ANSWER"
export const ADD_CATEGORY_QUESTION_STATUS = "ADD_CATEGORY_QUESTION_STATUS"
export const GET_CATEGORY_FROM_API_QUESTION = "GET_CATEGORY_FROM_API_QUESTION"
export const IS_FETCH_CATEGORY_FROM_API = "IS_FETCH_CATEGORY_FROM_API"
export const ADD_QUESTION_COVER_IMAGE = "ADD_QUESTION_COVER_IMAGE"
export const REMOVE_QUESTION_COVER_IMAGE = "REMOVE_QUESTION_COVER_IMAGE"
export const GET_SINGLE_QUESTION_DATA = "GET_SINGLE_QUESTION_DATA"
export const EDIT_QUESTION = "EDIT_QUESTION"
export const EDIT_DESCRIPTION_QUESTION = "EDIT_DESCRIPTION_QUESTION"
export const EDIT_IS_ANSWER = "EDIT_IS_ANSWER"
export const EDIT_TAGS_QUESTION = "EDIT_TAGS_QUESTION"
export const REMOVE_HEAD_IMAGE_QUESTION = "REMOVE_HEAD_IMAGE_QUESTION"
export const EDIT_HEAD_IMAGE_QUESTION = "EDIT_HEAD_IMAGE_QUESTION"
export const FETCH_CATEGORY_FROM_API_EDIT_QUESTION = "FETCH_CATEGORY_FROM_API_EDIT_QUESTION"
export const EDIT_CATEGORY_QUESTION_STATUS = "EDIT_CATEGORY_QUESTION_STATUS"
// QUESTION ENDS


// BLOGS ACTION
export const ADD_QUESTION_BLOGS = "ADD_QUESTION_BLOGS"
export const ADD_DESCRIPTION_BLOGS = "ADD_DESCRIPTION_BLOGS"
export const ADD_DATE_BLOGS = "ADD_DATE_BLOGS"
export const ADD_TAGS_BLOGS = "ADD_TAGS_BLOGS"
export const ADD_CATEGORY_BLOGS = "ADD_CATEGORY_BLOGS"
export const ADD_COMMENTS_BLOGS = "ADD_COMMENTS_BLOGS"
export const ADD_CATEGORY_BLOGS_STATUS = "ADD_CATEGORY_BLOGS_STATUS"
export const ADD_BLOG_CONTENT = "ADD_BLOG_CONTENT"
export const ADD_BLOG_COVER_IMAGE = "ADD_BLOG_COVER_IMAGE"
export const GET_CATEGORY_FROM_API = "GET_CATEGORY_FROM_API"
export const FETCH_CATEGORY_FROM_API = "FETCH_CATEGORY_FROM_API"
export const REMOVE_BLOG_COVER_IMAGE = "REMOVE_BLOG_COVER_IMAGE"
export const GET_SINGLE_POST_DATAS = "GET_SINGLE_POST_DATAS"
export const IS_SINGLE_POST_DATA_FETCH = "IS_SINGLE_POST_DATA_FETCH"
export const EDIT_QUESTION_BLOGS = "EDIT_QUESTION_BLOGS"
export const EDIT_DESCRIPTION_BLOGS = "EDIT_DESCRIPTION_BLOGS"
export const EDIT_BLOG_CONTENT = "EDIT_BLOG_CONTENT"
export const EDIT_IS_COMMENT = "EDIT_IS_COMMENT"
export const EDIT_TAGS_BLOGS = "EDIT_TAGS_BLOGS"
export const REMOVE_HEAD_IMAGE_BLOGS = "REMOVE_HEAD_IMAGE_BLOGS"
export const EDIT_HEAD_IMAGE_BLOGS = "EDIT_HEAD_IMAGE_BLOGS"
export const FETCH_CATEGORY_FROM_API_EDIT = "FETCH_CATEGORY_FROM_API_EDIT"
export const EDIT_CATEGORY_BLOGS_STATUS = "EDIT_CATEGORY_BLOGS_STATUS"
export const EMPTY_BLOG_EDIT_STATE = "EMPTY_BLOG_EDIT_STATE"
// BLOGS ACTION ENDS



// Master Data
export const SET_MASTER_DATA = "SET_MASTER_DATA"
export const SET_FIRST_NAME = "SET_FIRST_NAME"
export const SET_LAST_NAME = "SET_LAST_NAME"
export const SET_USER_NAME = "SET_USER_NAME"
export const SET_EMAIL = "SET_EMAIL"
export const SET_PHONE = "SET_PHONE"
export const SET_WEBSITE = "SET_WEBSITE"
export const SET_BIO = "SET_BIO"
export const SET_FB = "SET_FB"
export const SET_INSTA = "SET_INSTA"
export const SET_LINKIN = "SET_LINKIN"
export const SET_TWI = "SET_TWI"
export const SET_YT = "SET_YT"
export const SET_BE = "SET_BE"
export const SET_DRIBBLE = "SET_DRIBBLE"
export const SET_PIN = "SET_PIN"
export const SET_DOB = "SET_DOB"
export const SET_GENDER = "SET_GENDER"
export const SET_COUNTRY = "SET_COUNTRY"
export const SET_STATE = "SET_STATE"
export const SET_CITY = "SET_CITY"
export const SET_PINCODE = "SET_PINCODE"
export const SET_IS_PROFILE_LOADER = "SET_IS_PROFILE_LOADER"
export const SET_IS_PROFILE_PIC = "SET_IS_PROFILE_PIC"
export const SET_IS_BANNER_PIC = "SET_IS_BANNER_PIC"
export const SET_PASSWORD_ACCOUNT = "SET_PASSWORD_ACCOUNT"
export const SET_USER = "SET_USER"
export const SET_LANGUAGES = 'SET_LANGUAGES'
export const REMOVE_LANGUAGES = 'REMOVE_LANGUAGES'



// EDIT BLOG
export const IS_FETCHED_BLOG = "IS_FETCHED_BLOG"
export const IS_FETCHED_QUESTION = "IS_FETCHED_QUESTION"
export const RESET_BLOG_CONTENT = "RESET_BLOG_CONTENT"
export const RESET_QUESTION_CONTENT = "RESET_QUESTION_CONTENT"


// NOTIFICATION 
export const NOTIFICATION_DATA = "NOTIFICATION_DATA"
export const NOTIFICATION_UPDATE = "NOTIFICATION_UPDATE"


// CATEGORY
export const FETCH_CATEGORY = "FETCH_CATEGORY"
export const CLEAR_IMAGE_BLOG = "CLEAR_IMAGE_BLOG"
export const IS_MOBILE_SEARCH = "IS_MOBILE_SEARCH"


// RESUME
export const SET_RESUME_DATA = "SET_RESUME_DATA"
export const GET_RESUME_DATA = "GET_RESUME_DATA"
export const ADD_SKILLS = "ADD_SKILLS"  
export const ADD_SKILLS_TITLE = "ADD_SKILLS_TITLE"  
export const ADD_SKILLS_RANGE = "ADD_SKILLS_RANGE"  
export const SKILLS_RESET = "SKILLS_RESET"  
export const SKILLS_DELETE = "SKILLS_DELETE"  
export const CHECK_PROFILE = "CHECK_PROFILE" 
export const CHECK_BIO = "CHECK_BIO" 
export const CHECK_FULLNAME = "CHECK_FULLNAME" 
export const CHECK_ADDRESS = "CHECK_ADDRESS" 
export const CHECK_PHONE = "CHECK_PHONE" 
export const CHECK_EMAIL = "CHECK_EMAIL" 
export const CHECK_FB = "CHECK_FB" 
export const CHECK_LINKD = "CHECK_LINKD" 
export const CHECK_TW = "CHECK_TW" 
export const CHECK_DRIBBLE = "CHECK_DRIBBLE" 
export const CHECK_BE = "CHECK_BE"
export const CHECK_PIN = "CHECK_PIN" 
export const CHECK_INSTA = "CHECK_INSTA" 
export const CHECK_YT = "CHECK_YT" 
export const CHECK_EDUCATION = "CHECK_EDUCATION" 
export const CHECK_WORK = "CHECK_WORK" 
export const CHECK_PUBLIC = "CHECK_PUBLIC" 
export const CHECK_CERT = "CHECK_CERT" 
export const CHECK_EXTRA = "CHECK_EXTRA" 
export const CHECK_PROJECT = "CHECK_PROJECT" 
export const CHECK_ALL_PERSONAL_DETAIL = "CHECK_ALL_PERSONAL_DETAIL" 
export const CHECK_ALL_EDUCATION = "CHECK_ALL_EDUCATION" 
export const CHECK_ALL_WORK = "CHECK_ALL_WORK" 
export const CHECK_ALL_PUBLICATION = "CHECK_ALL_PUBLICATION" 
export const CHECK_ALL_CERTIFICATE = "CHECK_ALL_CERTIFICATE" 
export const CHECK_ALL_EXTRA = "CHECK_ALL_EXTRA" 
export const CHECK_ALL_PROJECT = "CHECK_ALL_PROJECT" 
export const UNCHECK_ALL_PERSONAL_DETAIL = "UNCHECK_ALL_PERSONAL_DETAIL" 
export const ADD_HOBBIES = "ADD_HOBBIES" 
export const EDIT_HOBBIES = "EDIT_HOBBIES" 
export const DELETE_HOBBIES = "DELETE_HOBBIES" 
export const EDIT_SKILLS = "EDIT_SKILLS" 
export const DELETE_SKILLS = "DELETE_SKILLS" 
export const SET_HOBBILES_IMAGE = "SET_HOBBILES_IMAGE" 



// RESUEM 

export const GET_ENTIRE_USER_DATA_RESUME = "GET_ENTIRE_USER_DATA_RESUME"
export const SET_TITLE_RESUME = "SET_TITLE_RESUME"
export const ADD_SKILL = "ADD_SKILL"
export const UPDATE_SKILL = "UPDATE_SKILL"
export const DELETE_SKILL = "DELETE_SKILL"

export const ADD_HOBBY = "ADD_HOBBY"
export const UPDATE_HOBBY = "UPDATE_HOBBY"
export const DELETE_HOBBY = "DELETE_HOBBY"
export const PHOTO_PRIVACY = "PHOTO_PRIVACY"
export const CERTIFICATE_PRIVACY = "CERTIFICATE_PRIVACY"
export const EDUCATION_PRIVACY = "EDUCATION_PRIVACY"
export const WORK_PRIVACY = "WORK_PRIVACY"
export const PROJECT_PRIVACY = "PROJECT_PRIVACY"
export const PUBLICATION_PRIVACY = "PUBLICATION_PRIVACY"
export const ORENTATION_RESUME = "ORENTATION_RESUME"
export const BACKGROUND_RESUME = "BACKGROUND_RESUME"
